module.exports = __webpack_public_path__ + "1d2386ff95d0e75bf44e61430f03cdd5.MP3";